import { validatorUuid } from './validators';

export class Uuid {
  static fromHexString(str: string): Uuid {
    return new Uuid(str);
  }

  static fromHexStringOrUndefined(str: string): Uuid | undefined {
    try {
      return new Uuid(str);
    } catch (e) {
      /*intentionally ignored*/
    }
  }

  static nullValue(): Uuid {
    return Uuid.fromHexString('00000000-0000-0000-0000-000000000000');
  }

  static validateAndFormat(str: string): string {
    if (!validatorUuid(str)) {
      return str;
    }

    const validUuidChars = str
      .trim()
      .toLowerCase()
      .split('')
      .filter(c => (c >= '0' && c <= '9') || (c >= 'a' && c <= 'f'));
    if (validUuidChars.length !== 32) {
      throw new TypeError(`invalid uuid length (${validUuidChars.length}/32) or invalid characters detected`);
    }

    validUuidChars.splice(20, 0, '-');
    validUuidChars.splice(16, 0, '-');
    validUuidChars.splice(12, 0, '-');
    validUuidChars.splice(8, 0, '-');

    return validUuidChars.join('');
  }

  private readonly hexString;

  private constructor(str: string) {
    this.hexString = Uuid.validateAndFormat(str);
  }

  toString(): string {
    return this.hexString;
  }

  toJSON(): string {
    return this.toString();
  }

  equals(other: Uuid): boolean {
    return other.hexString === this.hexString;
  }
}
